/**
 * Normalize publish API payload ({ success, message, data }) to the inner result object.
 */
export function parseAuctionPublishResponse(apiRes) {
  if (!apiRes || typeof apiRes !== "object") return {};
  const layer = apiRes.data !== undefined ? apiRes.data : apiRes;
  if (layer && typeof layer === "object" && layer.requires_approval !== undefined) {
    return layer;
  }
  if (layer?.data && typeof layer.data === "object") {
    return layer.data;
  }
  return layer && typeof layer === "object" ? layer : {};
}

export function auctionRequiresListingApproval(publishData) {
  if (!publishData || typeof publishData !== "object") return false;
  return (
    publishData.requires_approval === true ||
    publishData.listing_approval_status === "pending" ||
    (publishData.published === false && publishData.approval_request_id != null)
  );
}

export function isAuctionListingLive(auction) {
  if (!auction) return false;
  const status = String(auction.status || "");
  if (status === "pending_approval" || status === "rejected" || status === "draft") {
    return false;
  }
  if (auction.listing_approval_status === "pending" || auction.listing_approval_status === "rejected") {
    return false;
  }
  return status === "published" || status === "active" || status === "ended" || status === "extended";
}
